import { render, staticRenderFns } from "./FormToggle.vue?vue&type=template&id=6d7a7c12&scoped=true&"
import script from "./FormToggle.vue?vue&type=script&lang=js&"
export * from "./FormToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7a7c12",
  null
  
)

export default component.exports